import Environment from '@cobliteam/react-environments';
import { Button } from '@cobliteam/ui/components';
import { format } from '@cobliteam/utils/date';
import { Link } from 'react-router-dom';
import useSearch from '../../hooks/useSearch';

const env = Environment.getInstance().getEnvironment();

interface CardMapProps {
  title?: string;
  latitude?: number | null;
  longitude?: number | null;
  updatedAt?: number | null;
  linkTo: string;
}

const CardMap = ({ latitude, longitude, updatedAt, linkTo, title }: CardMapProps) => {
  const { setIsOpen } = useSearch();

  const isLocationValid = latitude && longitude;
  if (!isLocationValid) return null;

  return (
    <div className='flex flex-col gap-2'>
      <div className='flex flex-row items-center justify-between'>
        <div className='flex flex-col'>
          <div className='flex flex-row items-center gap-1'>
            <div className='font-medium text-xs'>{title || 'Localização do Veículo'}</div>
          </div>
          <div className='flex flex-row gap-1 text-gray-9'>
            <div className='text-xs'>Última atualização:</div>
            <div className='text-xs'>{updatedAt ? format(updatedAt, 'dd/MM/yyyy HH:mm') : '---'}</div>
          </div>
        </div>
        <div>
          <Link to={linkTo} onClick={() => setIsOpen(false)}>
            <Button className='h-6 text-xs' variant='link' size='sm'>
              Ver no mapa
            </Button>
          </Link>
        </div>
      </div>
      <div className='h-[200px] w-full overflow-hidden rounded-sm '>
        <Link to={linkTo} onClick={() => setIsOpen(false)}>
          <img
            width='328'
            className='transition-all duration-300 hover:scale-110'
            src={`
                  https://maps.googleapis.com/maps/api/staticmap?
                  auto=${latitude},${longitude}
                  &zoom=13
                  &scale=2
                  &size=328x164
                  &maptype=roadmap
                  &format=png
                  &markers=${latitude},${longitude}
                  &key=${env.googleMapsKey}`}
            alt='Google maps vehicle location'
          />
        </Link>
      </div>
    </div>
  );
};

export default CardMap;
